const partnerCenterBaseUrl =
  process.env.DEPLOYMENT_ENV === "production"
    ? "https://1s.microsoft.com"
    : "https://1s.microsoft-int.com";

export const partnerCenterEnrollmentApi = `${partnerCenterBaseUrl}/api/v1/enrollment/appdev`;

export const partnerCenterEnrollmentWorkflowApi = `${partnerCenterBaseUrl}/api/v1/enrollment/{referenceId}/status`;

export const partnerCenterGetAccountApi = `${partnerCenterBaseUrl}/api/v1/accounts`;

export const partnerCenterVettingStatusApiProd = `${partnerCenterBaseUrl}/api/v1/registration/{OneVetId}`;

export const partnerCenterFileUploadApi = `${partnerCenterBaseUrl}/api/v1/fileupload`;

export const signUpUrl = "https://signup.live.com/signup";
